import { Routes } from '@angular/router';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { SignupPageComponent } from './pages/signup-page/signup-page.component';
import { AiAgentConfigurationPageComponent } from './pages/ai-agent-configuration-page/ai-agent-configuration-page.component';
import { pathNames, variablePathNames } from './utilities/routing-path-utils';
import { ClientAccountActivationComponent } from './components/client-account-activation/client-account-activation.component';
import { LoginGuardService } from './guards/login-guard.service';
import { AuthGuardService } from './guards/auth-guard.service';
import { LostPasswordPageComponent } from './pages/lost-password-page/lost-password-page.component';
import { ValidateAccountPageComponent } from './pages/validate-account-page/validate-account-page.component';
import { PaymentPlansPageComponent } from './pages/payment-plans-page/payment-plans-page.component';
import { PaymentSuccessPageComponent } from './pages/payment-success-page/payment-success-page.component';
import { PaymentCancelPageComponent } from './pages/payment-cancel-page/payment-cancel-page.component';
import { AgencyPageComponent } from './pages/subaccount-page/subaccount-page.component';
import { RebillingPageComponent } from './pages/rebilling-page/rebilling-page.component';
import { UserSettingsPageComponent } from './pages/user-settings-page/user-settings-page.component';
import { AuthSuccessPageComponent } from './pages/auth-success-page/auth-success-page.component';
import { WhiteLabelGuardService } from './guards/white-label-guard.service';
import { AdminDashboardPageComponent } from './pages/admin-dashboard-page/admin-dashboard-page.component';
import { UserPhoneNumbersPageComponent } from './pages/user-phone-numbers-page/user-phone-numbers-page.component';
import { CustomDomainComponent } from './pages/custom-domain/custom-domain.component';

export const routes: Routes = [
    {
        path: '',
        children: [
            // AI ASSISTANT PATHS
            { path: '', canActivate: [AuthGuardService], component: AiAgentConfigurationPageComponent },
            { path: pathNames.aiAgentConfigurationPath, canActivate: [AuthGuardService], component: AiAgentConfigurationPageComponent },
            { path: `${pathNames.aiAgentConfigurationPath}/:${variablePathNames.subaccountUserIdPathVariable}`, canActivate: [AuthGuardService], component: AiAgentConfigurationPageComponent },

            // SETTINGS PATH
            { path: pathNames.userSettingsPath, canActivate: [AuthGuardService], component: UserSettingsPageComponent },

            // INTEGRATION PATH
            { path: pathNames.userPhoneNumbersPath, canActivate: [AuthGuardService], component: UserPhoneNumbersPageComponent },

            // AUTHENTICATION PATHS
            { path: pathNames.loginPath, canActivate: [LoginGuardService], component: LoginPageComponent },
            { path: pathNames.signUpPath, canActivate: [LoginGuardService], component: SignupPageComponent },
            { path: pathNames.lostPasswordPath, canActivate: [LoginGuardService], component: LostPasswordPageComponent },
            { path: `${pathNames.subaccountPath}/:${variablePathNames.subaccountPathVariable}`, canActivate: [LoginGuardService], component: SignupPageComponent },
            { path: `${pathNames.lostPasswordPath}/:${variablePathNames.lostPasswordPathVariable}`, component: LostPasswordPageComponent },
            { path: `${pathNames.validateAccountPath}/:${variablePathNames.validateAccountPathVariable}`, component: ValidateAccountPageComponent },
            { path: `${pathNames.activationPath}/:${variablePathNames.activationPathVariable}`, canActivate: [LoginGuardService], component: ClientAccountActivationComponent },

            // PAYMENT PATHS
            { path: pathNames.paymentPlansPath, canActivate: [AuthGuardService], component: PaymentPlansPageComponent },
            { path: `${pathNames.paymentSuccessPath}/:${variablePathNames.paymentPlanPathVariable}`, canActivate: [AuthGuardService], component: PaymentSuccessPageComponent },
            { path: pathNames.paymentSuccessPath, canActivate: [AuthGuardService], component: PaymentSuccessPageComponent },
            { path: pathNames.paymentCancelPath, canActivate: [AuthGuardService], component: PaymentCancelPageComponent },
            { path: pathNames.path404, component: NotFoundPageComponent },

            // AGENCY PATHS
            { path: pathNames.subaccountPath, canActivate: [AuthGuardService, WhiteLabelGuardService], component: AgencyPageComponent },
            { path: pathNames.rebillingPath, canActivate: [AuthGuardService, WhiteLabelGuardService], component: RebillingPageComponent },
            { path: pathNames.customDomain, canActivate: [AuthGuardService, WhiteLabelGuardService], component: CustomDomainComponent },

            // ADMIN PATHS
            { path: pathNames.adminDashboardPath, canActivate: [AuthGuardService], component: AdminDashboardPageComponent },

            //AUTH SUCESS PATHS
            { path: pathNames.oauthAuthSuccessPath, component: AuthSuccessPageComponent },


            { path: '**', redirectTo: pathNames.path404 }


        ]
    }
];
